/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { observable, action } from "mobx";

class OrganizeStore {
  @observable selectedSet;
  @observable insertPdfProgressLoaderIndex;
  @observable isInsertOpInProgress;
  @observable isRotateOpInProgress;
  @observable isOrganizeOpInProgress;
  dataSource;
  gridLayout;

  constructor() {
    this.init();
    this.selectedSet = new Set();
    this.dataSource = null;
    this.insertPdfProgressLoaderIndex = null;
    this.isInsertOpInProgress = false;
    this.isRotateOpInProgress = false;
    this.gridLayout = null;
  }

  initStore(docApi, stores) {
    if (docApi) {
      this.docApi = docApi;
    }
    if (stores) {
      this.stores = stores;
    }
  }

  @action
  init() {
    this.selectedSet = new Set();
    this.dataSource = null;
    this.insertPdfProgressLoaderIndex = null;
    this.gridLayout = null;
  }

  @action
  setSelectedSet(selectedSet) {
    this.selectedSet = selectedSet;
  }

  @action
  setInsertPdfProgressLoaderIndex(index) {
    this.insertPdfProgressLoaderIndex = index;
  }

  @action
  setIsOrganizeOpInProgress(value) {
    this.isOrganizeOpInProgress = value;
  }

  @action
  deleteItemsFromSelectedSet(keys) {
    const newSet = new Set(this.selectedSet);
    keys.forEach(key => {
      newSet.delete(key);
    });
    this.selectedSet = newSet;
  }

  @action
  setItemsForSelectedSet(keys) {
    const newSet = new Set(this.selectedSet);
    keys.forEach(key => {
      newSet.add(key);
    });
    this.selectedSet = newSet;
  }

  setThumbnailDataSource(dataSource) {
    this.dataSource = dataSource;
  }

  setGridLayout(gridLayout) {
    this.gridLayout = gridLayout;
  }
}

export { OrganizeStore };
